require("./dataset/DatasetModel");

var echarts = require("../echarts");

echarts.extendComponentView({
  type: 'dataset'
});